import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import InvoiceList from '../../../invoice/component/list/InvoiceList'


const mapStateToProps = (state, props) => {
    return {
        invoiceList: selector.selectInvoiceList(state),
        confirmationModalOpen: false,
        closeConfirmationModal: () => {},
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/InvoiceListWidgetContainer.js